/**
 * Category matching utilities for Kura Stash
 * Matches product names to categories based on keywords
 */

// Category keywords for matching product names
export const CATEGORY_KEYWORDS = {
  'cardstock': ['cardstock', 'card stock'],
  'patterned_paper': ['patterned paper', 'pattern paper', 'designer paper', 'scrapbook paper'],
  'die': ['die cut', 'die set', 'dies', 'cutting die', 'wafer die', 'thin die'],
  'stamp': ['stamp set', 'stamps', 'clear stamp', 'cling stamp', 'rubber stamp', 'photopolymer'],
  'stamp_pad': ['stamp pad', 'ink pad', 'distress ink', 'archival ink', 'pigment ink', 'dye ink'],
  'stencil': ['stencil', 'stencils'],
  'embossing_folder': ['embossing folder', '3d embossing', 'emboss folder'],
  'embellishment': ['embellishment', 'sequin', 'rhinestone', 'gem', 'pearl', 'brad', 'button', 'charm', 'enamel dot'],
  'sentiment': ['sentiment', 'sentiments'],
  'sticker': ['sticker', 'stickers', 'puffy sticker', 'chipboard'],
  'press_plate': ['press plate', 'letterpress', 'debossing plate'],
  'hot_foil_plate': ['hot foil', 'foil plate', 'glimmer plate', 'heatwave'],
};

/**
 * Match product name to category based on keywords
 * @param {string} productName - The product name to match
 * @returns {string} - The matched category value or empty string if no match
 */
export const matchCategoryFromName = (productName) => {
  if (!productName) return '';
  const nameLower = productName.toLowerCase();
  
  for (const [category, keywords] of Object.entries(CATEGORY_KEYWORDS)) {
    for (const keyword of keywords) {
      if (nameLower.includes(keyword)) {
        return category;
      }
    }
  }
  return ''; // No match found
};

export default matchCategoryFromName;
